import { API_NOTIFICATIONS_URL } from './notification-drawer.constants';
import { createReducer, INITIAL_STATE } from '../../shared/redux';
import {
    FETCH_NOTIFICATIONS_REQUEST_CALLED,
    FETCH_NOTIFICATIONS_REQUEST_FAIL,
    FETCH_NOTIFICATIONS_REQUEST_START,
    FETCH_NOTIFICATIONS_REQUEST_SUCCEEDED,
    NotificationState,
    NotificationsTypes,
    UPDATE_NOTIFICATION_REQUEST_CALLED,
    UPDATE_NOTIFICATION_REQUEST_FAIL,
    UPDATE_NOTIFICATION_REQUEST_SUCCEEDED,
    CLEAR_NOTIFICATIONS,
} from './notification-drawer.types';


export const getNotifications = state => state.notifications;

export const fetchNotifications = (clientId: number, {
    after,
}: { after? : string } = {}): NotificationsTypes => ({
    type: FETCH_NOTIFICATIONS_REQUEST_CALLED,
    actionTypes: {
        start: FETCH_NOTIFICATIONS_REQUEST_START,
        success: FETCH_NOTIFICATIONS_REQUEST_SUCCEEDED,
        fail: FETCH_NOTIFICATIONS_REQUEST_FAIL,
    },
    config: {
        url: `${API_NOTIFICATIONS_URL}/${clientId}`,
        method: 'GET',
        params: {
            after,
        },
    },
});

export const clearNotification = () => ({
    type: CLEAR_NOTIFICATIONS,
});

export const updateNotification = (
    clientId: number,
    notificationId: number,
) => ({
    type: UPDATE_NOTIFICATION_REQUEST_CALLED,
    actionTypes: {
        fail: UPDATE_NOTIFICATION_REQUEST_FAIL,
        success: UPDATE_NOTIFICATION_REQUEST_SUCCEEDED,
    },
    config: {
        url: `${API_NOTIFICATIONS_URL}/${clientId}`,
        method: 'PUT',
        data: {
            notification_id: notificationId,
        },
    },
});

const initialState: NotificationState = {
    loading: true,
    notifications: [],
};

export const notificationReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [FETCH_NOTIFICATIONS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        notifications: state.notifications.concat(action.payload.data),
        loading: false,
    }),
    [FETCH_NOTIFICATIONS_REQUEST_FAIL]: state => ({ ...state, loading: false }),
    [UPDATE_NOTIFICATION_REQUEST_CALLED]: (state, action) => ({
        ...state,
        notifications: state.notifications.map((notification) => {
            if (notification.id === action.config.data.notification_id) {
                return {
                    ...notification,
                    unread: false,
                };
            }

            return notification;
        }),
    }),
    [CLEAR_NOTIFICATIONS]: state => ({
        ...state,
        notifications: [],
    }),
});
